import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { Users, Lightning } from '@phosphor-icons/react';

const TribeDetail = () => {
  const { id } = useParams();
  const [tribe, setTribe] = useState(null);
  const [members, setMembers] = useState([]);

  const load = async () => {
    const { data } = await api.get(`/tribes/${id}`);
    setTribe(data.tribe);
    setMembers(data.members);
  };
  useEffect(() => { load(); }, [id]);

  const join = async () => {
    try { await api.post(`/tribes/${id}/join`); toast.success('Joined'); load(); }
    catch (err) { toast.error(err?.response?.data?.detail || 'failed'); }
  };

  if (!tribe) return <div className="text-center py-20 text-white/65">loading…</div>;

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-8 py-10 pb-24">
      <div className="glass rounded-2xl p-8">
        <div className="chip text-bx-cyan border-bx-cyan/30">{tribe.tag}</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-3">{tribe.name}</h1>
        <p className="text-white/70 mt-2">{tribe.description}</p>
        <div className="mt-5 flex items-center gap-4 text-sm">
          <span className="flex items-center gap-1 text-bx-volt font-bold"><Lightning size={14} weight="fill" /> {tribe.energy} energy</span>
          <span className="flex items-center gap-1 text-white/60"><Users size={14} weight="bold" /> {members.length} members</span>
          <button data-testid="tribe-join-now" onClick={join} className="btn-volt px-4 py-1.5 rounded-full text-xs ml-auto">Join Tribe</button>
        </div>
      </div>

      <h2 className="font-display text-2xl font-bold mt-10 mb-4">Members</h2>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3">
        {members.map((m) => (
          <div key={m.id} data-testid={`tribe-member-${m.id}`} className="glass rounded-xl p-3 text-center">
            <div className="h-14 w-14 mx-auto rounded-full bg-gradient-to-br from-bx-cyan to-bx-magenta grid place-items-center font-display font-black text-base">
              {m.username?.[0]?.toUpperCase()}
            </div>
            <div className="text-xs font-bold mt-2 truncate">@{m.username}</div>
            <div className="text-[10px] uppercase tracking-widest text-white/60 mt-0.5">L{m.level || 1}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TribeDetail;
